import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { userChannelList } from '@/api/gmtool/packageCode';
export default {
  props: {
    activests: {
      type: String,
      data: function data() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      date2: [],
      tableData: [],
      tableDataList: [],
      screen: [],
      screenList: [{
        label: this.$t('rechargeLabel'),
        prop: "account_recharge_amount",
        width: "74"
      }, // {
      //   label:'充值货币',
      //   prop:''
      // },
      {
        label: this.$t('accountArpu'),
        prop: "account_arpu",
        width: "83"
      }, {
        label: this.$t('accountArppu'),
        prop: "account_arppu",
        width: "92"
      }, {
        label: this.$t('registerDeviceNum'),
        prop: "register_device_pnum",
        width: "83"
      }, {
        label: this.$t('registerAccountNum'),
        prop: "register_account_pnum",
        width: "83"
      }, {
        label: this.$t('loginDeviceNum'),
        prop: "login_device_pnum",
        width: "83"
      }, {
        label: this.$t('loginAccountNum'),
        prop: "login_account_pnum",
        width: "83"
      }, {
        label: this.$t('registerNotLoginDeviceNum'),
        prop: "diff_device_register_login",
        width: "119"
      }, {
        label: this.$t('registerNotLoginAccountNum'),
        prop: "diff_account_register_login",
        width: "119"
      }, {
        label: this.$t('activeDeviceNum'),
        prop: "active_device_pnum",
        width: "83"
      }, {
        label: this.$t('activeAccountNum'),
        prop: "active_account_pnum",
        width: "83"
      }, {
        label: this.$t('rechargeDeviceNum'),
        prop: "recharge_device_pnum",
        width: "83"
      }, {
        label: this.$t('rechargeAccountNum'),
        prop: "recharge_account_pnum",
        width: "83"
      }, {
        label: this.$t('registerAccountRecharge'),
        prop: "register_recharge_account_amount",
        width: "95"
      }, {
        label: this.$t('registerDeviceRecharge'),
        prop: "register_recharge_device_amount",
        width: "95"
      }, {
        label: this.$t('registerAccountRechargeNum'),
        prop: "register_recharge_account_pnum",
        width: "107"
      }, {
        label: this.$t('registerDeviceRechargeNum'),
        prop: "register_recharge_device_pnum",
        width: "107"
      }, {
        label: this.$t('firstRechargeAccountAmount'),
        prop: "first_recharge_account_amount",
        width: "95"
      }, {
        label: this.$t('firstRechargeDeviceAmount'),
        prop: "first_recharge_device_amount",
        width: "95"
      }, {
        label: this.$t('firstRechargeAccountNum'),
        prop: "first_recharge_account_pnum",
        width: "83"
      }, {
        label: this.$t('firstRechargeDeviceNum'),
        prop: "first_recharge_device_pnum",
        width: "83"
      }],
      screenListP: [{
        label: this.$t('rechargeLabel'),
        prop: "account_recharge_amount",
        width: "74"
      }, // {
      //   label:'充值货币',
      //   prop:''
      // },
      {
        label: this.$t('accountArpu'),
        prop: "account_arpu",
        width: "83"
      }, {
        label: this.$t('accountArppu'),
        prop: "account_arppu",
        width: "92"
      }, {
        label: this.$t('registerDeviceNum'),
        prop: "register_device_pnum",
        width: "83"
      }, {
        label: this.$t('registerAccountNum'),
        prop: "register_account_pnum",
        width: "83"
      }, {
        label: this.$t('loginDeviceNum'),
        prop: "login_device_pnum",
        width: "83"
      }, {
        label: this.$t('loginAccountNum'),
        prop: "login_account_pnum",
        width: "83"
      }, {
        label: this.$t('registerNotLoginDeviceNum'),
        prop: "diff_device_register_login",
        width: "119"
      }, {
        label: this.$t('registerNotLoginAccountNum'),
        prop: "diff_account_register_login",
        width: "119"
      }, {
        label: this.$t('activeDeviceNum'),
        prop: "active_device_pnum",
        width: "83"
      }, {
        label: this.$t('activeAccountNum'),
        prop: "active_account_pnum",
        width: "83"
      }, {
        label: this.$t('rechargeDeviceNum'),
        prop: "recharge_device_pnum",
        width: "83"
      }, {
        label: this.$t('rechargeAccountNum'),
        prop: "recharge_account_pnum",
        width: "83"
      }, {
        label: this.$t('registerAccountRecharge'),
        prop: "register_recharge_account_amount",
        width: "95"
      }, {
        label: this.$t('registerDeviceRecharge'),
        prop: "register_recharge_device_amount",
        width: "95"
      }, {
        label: this.$t('registerAccountRechargeNum'),
        prop: "register_recharge_account_pnum",
        width: "107"
      }, {
        label: this.$t('registerDeviceRechargeNum'),
        prop: "register_recharge_device_pnum",
        width: "107"
      }, {
        label: this.$t('firstRechargeAccountAmount'),
        prop: "first_recharge_account_amount",
        width: "95"
      }, {
        label: this.$t('firstRechargeDeviceAmount'),
        prop: "first_recharge_device_amount",
        width: "95"
      }, {
        label: this.$t('firstRechargeAccountNum'),
        prop: "first_recharge_account_pnum",
        width: "83"
      }, {
        label: this.$t('firstRechargeDeviceNum'),
        prop: "first_recharge_device_pnum",
        width: "83"
      }],
      screenListVND: [{
        label: this.$t('rechargeLabel'),
        prop: "account_recharge_amount",
        width: "74"
      }, {
        label: this.$t('rechargeUsd'),
        prop: "account_recharge_amountexchange",
        width: "110"
      }, // {
      //   label:'充值货币',
      //   prop:''
      // },
      {
        label: this.$t('accountArpu'),
        prop: "account_arpu",
        width: "83"
      }, {
        label: this.$t('accountArppu'),
        prop: "account_arppu",
        width: "92"
      }, {
        label: this.$t('registerDeviceNum'),
        prop: "register_device_pnum",
        width: "83"
      }, {
        label: this.$t('registerAccountNum'),
        prop: "register_account_pnum",
        width: "83"
      }, {
        label: this.$t('loginDeviceNum'),
        prop: "login_device_pnum",
        width: "83"
      }, {
        label: this.$t('loginAccountNum'),
        prop: "login_account_pnum",
        width: "83"
      }, {
        label: this.$t('registerNotLoginDeviceNum'),
        prop: "diff_device_register_login",
        width: "119"
      }, {
        label: this.$t('registerNotLoginAccountNum'),
        prop: "diff_account_register_login",
        width: "119"
      }, {
        label: this.$t('activeDeviceNum'),
        prop: "active_device_pnum",
        width: "83"
      }, {
        label: this.$t('activeAccountNum'),
        prop: "active_account_pnum",
        width: "83"
      }, {
        label: this.$t('rechargeDeviceNum'),
        prop: "recharge_device_pnum",
        width: "83"
      }, {
        label: this.$t('rechargeAccountNum'),
        prop: "recharge_account_pnum",
        width: "83"
      }, {
        label: this.$t('registerAccountRecharge'),
        prop: "register_recharge_account_amount",
        width: "95"
      }, {
        label: this.$t('registerAccountRechargeUsd'),
        prop: "register_recharge_account_amountexchange",
        width: "140"
      }, {
        label: this.$t('registerDeviceRecharge'),
        prop: "register_recharge_device_amount",
        width: "95"
      }, {
        label: this.$t('registerDeviceRechargeUsd'),
        prop: "register_recharge_device_amountexchange",
        width: "140"
      }, {
        label: this.$t('registerAccountRechargeNum'),
        prop: "register_recharge_account_pnum",
        width: "107"
      }, {
        label: this.$t('registerDeviceRechargeNum'),
        prop: "register_recharge_device_pnum",
        width: "107"
      }, {
        label: this.$t('firstRechargeAccountAmount'),
        prop: "first_recharge_account_amount",
        width: "95"
      }, {
        label: this.$t('firstRechargeDeviceAmount'),
        prop: "first_recharge_device_amount",
        width: "95"
      }, {
        label: this.$t('firstRechargeAccountNum'),
        prop: "first_recharge_account_pnum",
        width: "83"
      }, {
        label: this.$t('firstRechargeDeviceNum'),
        prop: "first_recharge_device_pnum",
        width: "83"
      }],
      screenListUSD: [{
        label: this.$t('rechargeLabel'),
        prop: "account_recharge_amount",
        width: "74"
      }, {
        label: this.$t('rechargeVnd'),
        prop: "account_recharge_amountexchange",
        width: "110"
      }, // {
      //   label:'充值货币',
      //   prop:''
      // },
      {
        label: this.$t('accountArpu'),
        prop: "account_arpu",
        width: "83"
      }, {
        label: this.$t('accountArppu'),
        prop: "account_arppu",
        width: "92"
      }, {
        label: this.$t('registerDeviceNum'),
        prop: "register_device_pnum",
        width: "83"
      }, {
        label: this.$t('registerAccountNum'),
        prop: "register_account_pnum",
        width: "83"
      }, {
        label: this.$t('loginDeviceNum'),
        prop: "login_device_pnum",
        width: "83"
      }, {
        label: this.$t('loginAccountNum'),
        prop: "login_account_pnum",
        width: "83"
      }, {
        label: this.$t('registerNotLoginDeviceNum'),
        prop: "diff_device_register_login",
        width: "119"
      }, {
        label: this.$t('registerNotLoginAccountNum'),
        prop: "diff_account_register_login",
        width: "119"
      }, {
        label: this.$t('activeDeviceNum'),
        prop: "active_device_pnum",
        width: "83"
      }, {
        label: this.$t('activeAccountNum'),
        prop: "active_account_pnum",
        width: "83"
      }, {
        label: this.$t('rechargeDeviceNum'),
        prop: "recharge_device_pnum",
        width: "83"
      }, {
        label: this.$t('rechargeAccountNum'),
        prop: "recharge_account_pnum",
        width: "83"
      }, {
        label: this.$t('registerAccountRecharge'),
        prop: "register_recharge_account_amount",
        width: "95"
      }, {
        label: this.$t('registerAccountRechargeVnd'),
        prop: "register_recharge_account_amountexchange",
        width: "140"
      }, {
        label: this.$t('registerDeviceRecharge'),
        prop: "register_recharge_device_amount",
        width: "95"
      }, {
        label: this.$t('registerDeviceRechargeVnd'),
        prop: "register_recharge_device_amountexchange",
        width: "140"
      }, {
        label: this.$t('registerAccountRechargeNum'),
        prop: "register_recharge_account_pnum",
        width: "107"
      }, {
        label: this.$t('registerDeviceRechargeNum'),
        prop: "register_recharge_device_pnum",
        width: "107"
      }, {
        label: this.$t('firstRechargeAccountAmount'),
        prop: "first_recharge_account_amount",
        width: "95"
      }, {
        label: this.$t('firstRechargeDeviceAmount'),
        prop: "first_recharge_device_amount",
        width: "95"
      }, {
        label: this.$t('firstRechargeAccountNum'),
        prop: "first_recharge_account_pnum",
        width: "83"
      }, {
        label: this.$t('firstRechargeDeviceNum'),
        prop: "first_recharge_device_pnum",
        width: "83"
      }],
      baseScreenListP: [{
        label: this.$t('channelId'),
        prop: 'channel_mark',
        width: '110'
      }, {
        label: this.$t('channelName'),
        prop: 'channel_name',
        width: '130'
      }, {
        label: this.$t('time'),
        prop: 'hours',
        width: '90'
      }, {
        label: this.$t('iapRevenue'),
        prop: 'inner_purchase_income',
        width: '110'
      }, {
        label: this.$t('totalRevenueLabel'),
        prop: 'total_income',
        width: '100'
      }, {
        label: this.$t('activeAccountLabel'),
        prop: 'active_account_num',
        width: '90'
      }, {
        label: this.$t('newAccountLabel'),
        prop: 'new_account_num',
        width: '90'
      }, {
        label: this.$t('newActiveRatio'),
        prop: 'new_active_ratio',
        width: '100'
      }, {
        label: this.$t('nonNewActiveAccountNum'),
        prop: 'non_new_active_account_num',
        width: '130'
      }, {
        label: this.$t('payAccountLabel'),
        prop: 'pay_account_num',
        width: '90'
      }, {
        label: this.$t('activeArpuLabel'),
        prop: 'active_arpu',
        width: '130'
      }, {
        label: this.$t('payArppuLabel'),
        prop: 'pay_arppu',
        width: '130'
      }, {
        label: this.$t('newDeviceLabel'),
        prop: 'new_device_num',
        width: '90'
      }, {
        label: this.$t('newDeviceAccountRatio'),
        prop: 'new_device_account_ratio',
        width: '120'
      }, {
        label: this.$t('newAccountRechargeAmount'),
        prop: 'new_account_recharge_amount',
        width: '130'
      }, {
        label: this.$t('newPayAccountNum'),
        prop: 'new_pay_account_num',
        width: '120'
      }, {
        label: this.$t('newPayRate'),
        prop: 'new_pay_rate',
        width: '100'
      }, {
        label: this.$t('newAccountArpu'),
        prop: 'new_account_arpu',
        width: '130'
      }, {
        label: this.$t('newPayAccountArppu'),
        prop: 'new_pay_account_arppu',
        width: '150'
      }, {
        label: this.$t('newDeviceRechargeAmountLabel'),
        prop: 'new_device_recharge_amount',
        width: '130'
      }, {
        label: this.$t('newDeviceRechargeNumLabel'),
        prop: 'new_device_recharge_num',
        width: '120'
      }, {
        label: this.$t('adIncomeLabel'),
        prop: 'ad_income',
        width: '90'
      }, {
        label: this.$t('activeAvgContribution'),
        prop: 'active_avg_contribution',
        width: '110'
      }, {
        label: this.$t('nextDayRetainNum'),
        prop: 'next_day_retain_num',
        width: '100'
      }, {
        label: this.$t('douLabel'),
        prop: 'dou',
        width: '110'
      }, {
        label: this.$t('pouLabel'),
        prop: 'pou',
        width: '130'
      }, {
        label: this.$t('oprLabel'),
        prop: 'opr',
        width: '130'
      }, {
        label: this.$t('dorpuLabel'),
        prop: 'dorpu',
        width: '180'
      }, {
        label: this.$t('dorppuLabel'),
        prop: 'dorppu',
        width: '190'
      }],
      collectNum: ["register_device_pnum", "register_account_pnum", "login_device_pnum", "login_account_pnum", "diff_device_register_login", "diff_account_register_login", "active_device_pnum", "active_account_pnum", "recharge_device_pnum", "recharge_account_pnum", "register_recharge_device_pnum", "first_recharge_account_pnum", "first_recharge_device_pnum", "account_arpu", "account_arppu"],
      collectAm: ["account_recharge_amount", "register_recharge_account_amount", "register_recharge_device_amount", "first_recharge_account_amount", "first_recharge_device_amount"],
      processingList: ["account_recharge_amount", "register_recharge_account_amount", "register_recharge_device_amount", "first_recharge_account_amount", "first_recharge_device_amount", "account_arpu", "account_arppu", "register_recharge_account_amountexchange", "register_recharge_device_amountexchange", "account_recharge_amountexchange"],
      processingListTow: ["account_recharge_amount", "register_recharge_account_amount", "register_recharge_device_amount", "first_recharge_account_amount", "first_recharge_device_amount", "register_recharge_account_amountexchange", "register_recharge_device_amountexchange", "account_recharge_amountexchange"],
      isQuery: false,
      channelList: [],
      channelChecked: true,
      dynamicKeyMap: {
        ltv: {
          name: 'LTV',
          width: '80'
        },
        ac_device_ltv: {
          name: '激活设备LTV',
          width: '110'
        },
        roi: {
          name: 'ROI',
          width: '80'
        },
        rr: {
          name: 'RR',
          width: '80'
        },
        pay_rr: {
          name: '付费账号RR',
          width: '100'
        }
      }
    };
  },
  watch: {
    activests: {
      handler: function handler(val) {
        if (this.name == val && !this.isQuery && this.name != '') {
          this.isQuery = true;
          this.searchClick();
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.getDate && this.getDate();
    this.getChannel(); // setTimeout(() => {
    //   this.searchClick();
    // }, 500);
    // this.$bus.$on("upd", () => {
    //   this.searchClick();
    // });
  },
  methods: {
    // 统一筛选功能
    screenChange: function screenChange() {
      var _this = this;

      var list = [];
      this.screenList.map(function (item) {
        if (_this.screen.findIndex(function (t) {
          return t == item.prop;
        }) > -1) {
          list.push(item);
        }
      });
      this.tableDataList = list;
    },
    //
    handleSelect: function handleSelect(e) {
      var _this2 = this;

      this.activeIndex = e;
      this.$nextTick(function () {
        setTimeout(function () {
          _this2["echart" + e] && _this2["echart" + e].resize();
        }, 300);
      });
    },
    getChannel: function getChannel() {
      var _this3 = this;

      userChannelList({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this3.channelList = res.data;
          _this3.searchData.channel_list = res.data.map(function (item) {
            return item.channel_mark;
          });
          _this3.channelChecked = true;
        }
      });
    },
    chanelChange: function chanelChange(val) {
      if (val) {
        // 全选
        this.searchData.channel_list = this.channelList.map(function (item) {
          return item.channel_mark;
        });
      } else {
        // 清空
        this.searchData.channel_list = [];
      }

      this.isIndeterminate = false;
    },
    // 3. 监听 el-select 值改变，同步全选和半选状态
    selectChange: function selectChange(val) {
      var totalCount = this.channelList.length;
      var selectedCount = val.length;
      this.channelChecked = selectedCount === totalCount && totalCount > 0;
    },
    searchClickLoop: function searchClickLoop(reqFn) {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var num, time, dates, datesList, i, _list, times, list, _i, qd;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                num = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 10;
                time = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : ['date'];
                _this4.reqLoading = true;
                _this4.isLoop = true;
                dates = _this4.$times.getDayAll(_this4.value2[0], _this4.value2[1]);
                console.log("dates==", dates);
                datesList = [];

                for (i = 0; i < dates.length; i += num) {
                  _list = dates.slice(i, i + num);
                  times = {};
                  times[time[0]] = _list[0]; // times[time[1]] = list[list.length - 1]

                  datesList.push(times);
                }

                console.log("datesList===", datesList);
                list = [];
                _i = 0;

              case 11:
                if (!(_i < datesList.length)) {
                  _context.next = 30;
                  break;
                }

                if (!_this4.isLoop) {
                  _context.next = 25;
                  break;
                }

                _context.next = 15;
                return reqFn(_objectSpread(_objectSpread(_objectSpread({}, _this4.searchData), datesList[_i]), _this4.defaultData()));

              case 15:
                qd = _context.sent;

                if (!(qd.status == 200 || qd.code == 200)) {
                  _context.next = 21;
                  break;
                }

                list.push(_objectSpread(_objectSpread({}, qd.data), {}, {
                  searchdate: datesList[_i]
                }));

                _this4.searchClickNew(list);

                _context.next = 23;
                break;

              case 21:
                _this4.reqLoading = false;
                return _context.abrupt("break", 30);

              case 23:
                _context.next = 27;
                break;

              case 25:
                _this4.reqLoading = false;
                return _context.abrupt("break", 30);

              case 27:
                _i++;
                _context.next = 11;
                break;

              case 30:
                _this4.reqLoading = false;

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};